import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import SEO from '@/components/SEO';
import Navigation from '@/components/Navigation';
import Footer from '@/components/Footer';
import HeroSection from '@/components/home/HeroSection';
import PodcastSection from '@/components/home/PodcastSection';
import ClientLogosSection from '@/components/home/ClientLogosSection';
import AudienceSplitSection from '@/components/home/AudienceSplitSection';
import SolutionsSection from '@/components/home/SolutionsSection';
import ConsultingSection from '@/components/home/ConsultingSection';
import CTASection from '@/components/home/CTASection';
import IntegrationSection from '@/components/home/IntegrationSection';
import ValuesSection from '@/components/home/ValuesSection';
import AudienceReminderSection from '@/components/home/AudienceReminderSection';
import useScrollReveal from '@/hooks/useScrollReveal';
import { useLanguage } from '@/contexts/language/LanguageContext';
import { homeCopy } from '@/contexts/language/translations/pages/home';

const Index = () => {
  const location = useLocation();
  const { language } = useLanguage();
  const c = homeCopy[language];

  // Scroll to the section named by the hash when opening the main page with one
  // (e.g. #solutions from the How It Works crosslink)
  useEffect(() => {
    if (!location.hash) return;
    const id = location.hash.slice(1);
    const timer = setTimeout(() => {
      const el = document.getElementById(id);
      el?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 100);
    return () => clearTimeout(timer);
  }, [location.pathname, location.hash]);

  // Add scroll reveal effect
  useScrollReveal();

  return (
    <div className="flex flex-col min-h-screen">
      <SEO
        title={c.seo.title}
        description={c.seo.description}
        canonical="/"
      />
      <Navigation />
      {/* --announce-h = height of the webinar strip under the fixed navigation (0 when hidden) */}
      <main className="index-page px-7 md:px-10" style={{ paddingTop: 'var(--announce-h, 0px)' }}>
        <HeroSection />
        <ClientLogosSection />
        <PodcastSection className="pt-2 bg-white" />
        <AudienceSplitSection />
        <SolutionsSection />
        <ConsultingSection />
        <IntegrationSection />
        <ValuesSection />
        <CTASection />
        <AudienceReminderSection />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
